export const RoutesPaths = {
  ROOT: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/secret-reset/:token',
  CHANGE_PASSWORD: '/change-password',
  SETTINGS: '/settings',
  PAY_BY_LINK: '/pay-by-link',
  PAY_BY_LINK_NEW: '/pay-by-link/new',
  PAY_BY_LINK_EDIT: '/pay-by-link/edit/:code',
  SHOP_NEW: '/shop/new',
  SETTLEMENTS: '/settlements',
  SHOPIFY_AUTHENTICATE: '/shopify-authenticate',
  DISBURSEMENTS: '/disbursements'
};
